import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import {
  createProjectCost,
  updateProjectCost,
  getProjectCostById,
} from '../../../axios/ProjectCostAxios';
import Swal from 'sweetalert2';
import { Link, useNavigate, useParams } from 'react-router-dom';
import LoadingOverlay from '../../../components/LoadingOverlay';

export const ProjectCostAdd = () => {
  const navigation = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    prjCost_code: '',
    name1: '',
    name2: '',
    name3: '',
    name4: '',
    level: '',
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const [breadcrumbItems, setBreadcrumbItems] = useState([
    { label: 'Dashboard', href: '/' },
    { label: 'Budgeting Project Code', href: '/project-cost' },
    { label: 'Create Budgeting Project Code' },
  ]);

  // Set breadcrumb based on the presence of 'id'
  useEffect(() => {
    if (id) {
      setBreadcrumbItems([
        { label: 'Dashboard', href: '/' },
        { label: 'Project Cost', href: '/project-cost' },
        { label: 'Update Project Cost' },
      ]);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      const fetchProjectCostData = async () => {
        try {
          setMessage('Fetching data...');
          setLoading(true);
          const response = await getProjectCostById(id); // Get data by ID from backend
          setFormData(response); // Populate form with fetched data
        } catch (error) {
          console.error('Error fetching new transaction data:', error);
        } finally {
          setLoading(false);
        }
      };
      fetchProjectCostData();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    if (!form.checkValidity()) {
      form.classList.add('was-validated');
      return;
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
        denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
        cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
      },
      buttonsStyling: false,
    });

    try {
      const result = await swalWithBootstrapButtons.fire({
        title: 'Do you want to save the data?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Save',
        cancelButtonText: `Don't save`,
      });

      if (result.isConfirmed) {
        try {
          setMessage('Saving data...');
          setLoading(true);
          if (id) {
            await updateProjectCost(id, formData);
            swalWithBootstrapButtons.fire(
              'Saved!',
              'The project-cost has been updated.',
              'success'
            );
          } else {
            await createProjectCost(formData);
            // Jika berhasil, tampilkan pesan sukses
            swalWithBootstrapButtons.fire(
              'Saved!',
              'The project-cost has been created.',
              'success'
            );
          }
          navigation('/project-cost');
        } catch (createNewTransacError) {
          // Jika ada kesalahan saat membuat akun, tampilkan pesan kesalahan
          swalWithBootstrapButtons.fire({
            title: 'Error!',
            text: createNewTransacError.message,
            icon: 'error',
          });
        } finally {
          setLoading(false);
        }
      } else if (result.isDenied) {
        swalWithBootstrapButtons.fire('Changes are not saved', '', 'info');
      }
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: 'Error!',
        text: 'There was an error processing your request.',
        icon: 'error',
      });
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const formElements = Array.from(e.target.form.elements);
      const index = formElements.indexOf(e.target);
      formElements[index + 1]?.focus();
    }
  };

  const handleCancel = (event) => {
    event.preventDefault();

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
        denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
        cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: 'All your input will be lost!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, cancel it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.isConfirmed) {
          const form = document.querySelector('.needs-validation');
          form.reset();
          setFormData({
            prjCost_code: '',
            name1: '',
            name2: '',
            name3: '',
            name4: '',
            level: '',
          });
          form.classList.remove('was-validated');
        }
      });
  };

  return (
    <div>
      <LoadingOverlay show={loading} message={message} />
      <Breadcrumb items={breadcrumbItems}></Breadcrumb>
      <form
        className="needs-validation"
        noValidate
        autocomplete="off"
        onSubmit={handleSubmit}
      >
        <div className="row">
          <div className="col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="validationExtCode" className="form-label">
                    Project ID
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationExtCode"
                    name="prjCost_code"
                    value={formData.prjCost_code}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Name 1</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationName1"
                    name="name1"
                    value={formData.name1}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Name 2</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationName2"
                    name="name2"
                    value={formData.name2}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">Name 3</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationName3"
                    name="name3"
                    value={formData.name3}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Name 4</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationName4"
                    name="name4"
                    value={formData.name4}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Level</label>
                  <select
                    className="form-select form-select-sm"
                    aria-label="Small select example"
                    name="level"
                    value={formData.level}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Choose...</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                  </select>
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
              </div>
            </div>
            <div className="button-navigatsi">
              <div className="">
                <button type="submit" className="btn btn-primary">
                  <i className="bi bi-send"></i>
                  <span> Submit</span>
                </button>
              </div>
              <div className="">
                <button
                  type="reset"
                  className="btn btn-danger btn-cancel"
                  onClick={handleCancel}
                >
                  <i className="bi bi-x-circle"></i>
                  <span> Cancel</span>
                </button>
              </div>
              <div className="">
                <Link
                  type="button"
                  className="btn btn-warning"
                  to="/project-cost"
                >
                  <i className="bi bi-arrow-left-circle"></i>
                  <span> Back</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
